import { usePathParams } from 'components/Navigation/NavStack';
import React, { useMemo } from 'react';
import { Stepper } from 'components/Utils/Stepper';
import DefaultButton from 'components/Utils/NewDefaultButton';
import { REGISTRATION_STEPS } from 'scenes/PatientRegistration/RegistrationUtils';

export const RegistrationBottomNavigation = ({ id, disabled, loading }) => {
  const params = usePathParams();

  const currentStep = useMemo(() => {
    switch (params.step) {
      case REGISTRATION_STEPS.credentials.route:
        return 0;
      case REGISTRATION_STEPS.personal.route:
        return 1;
      case REGISTRATION_STEPS.phone.route:
        return 2;
      case REGISTRATION_STEPS.verification.route:
        return 3;
      default:
        return 0;
    }
  }, [params.step]);

  return (
    <BottomNavigation
      id={id}
      disabled={disabled}
      loading={loading}
      steps={4}
      currentStep={currentStep}
    />
  );
};

export const BottomNavigation = ({ id, disabled, loading, steps = 4, currentStep, onClick }) => {
  return (
    <div className="bottom-navigation">
      <div className="controls-wrapper">
        <Stepper steps={steps} currentStep={currentStep} />
        <div className="button-wrapper">
          <DefaultButton
            id={id}
            name="Next"
            disabled={disabled}
            loading={loading}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  );
};
